import { ComponentWithAs, createIcon, IconProps } from "@chakra-ui/react";

export const accountIcon = (
  color: string,
): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.5 0.25C4.21875 0.25 0.75 3.71875 0.75 8C0.75 12.2812 4.21875 15.75 8.5 15.75C12.7812 15.75 16.25 12.2812 16.25 8C16.25 3.71875 12.7812 0.25 8.5 0.25ZM8.5 3.25C10 3.25 11.25 4.5 11.25 6C11.25 7.53125 10 8.75 8.5 8.75C6.96875 8.75 5.75 7.53125 5.75 6C5.75 4.5 6.96875 3.25 8.5 3.25ZM8.5 14C6.65625 14 5 13.1875 3.90625 11.875C4.5 10.7812 5.65625 10 7 10C7.0625 10 7.125 10.0312 7.21875 10.0625C7.625 10.1875 8.03125 10.25 8.5 10.25C8.9375 10.25 9.375 10.1875 9.75 10.0625C9.84375 10.0312 9.90625 10 10 10C11.3125 10 12.4688 10.7812 13.0625 11.875C11.9688 13.1875 10.3125 14 8.5 14Z"
          fill={color}
        />
      </svg>
    ),
  });
};

export const uploadIcon = (
  color: string,
): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.25152 17C7.25152 17.4142 7.58731 17.75 8.00152 17.75C8.41573 17.75 8.75152 17.4142 8.75152 17H7.25152ZM8.00152 6.33333L8.53185 5.803C8.23896 5.51011 7.76408 5.51011 7.47119 5.803L8.00152 6.33333ZM10.6712 10.0637C10.9641 10.3566 11.439 10.3566 11.7319 10.0637C12.0247 9.77077 12.0247 9.2959 11.7319 9.003L10.6712 10.0637ZM4.27119 9.003C3.9783 9.2959 3.9783 9.77077 4.27119 10.0637C4.56408 10.3566 5.03896 10.3566 5.33185 10.0637L4.27119 9.003ZM5.33485 15.0826C5.74907 15.0826 6.08485 14.7468 6.08485 14.3326C6.08485 13.9184 5.74907 13.5826 5.33485 13.5826V15.0826ZM3.73343 14.3326V15.0826V14.3326ZM1.6001 12.1993H0.850098H1.6001ZM1.6001 3.13333H0.850098H1.6001ZM3.73343 1V0.25V1ZM12.2668 1V0.25V1ZM14.4001 3.13333H15.1501H14.4001ZM14.4001 12.1993H15.1501H14.4001ZM12.2668 14.3326V15.0826V14.3326ZM10.6668 13.5826C10.2526 13.5826 9.91676 13.9184 9.91676 14.3326C9.91676 14.7468 10.2526 15.0826 10.6668 15.0826V13.5826ZM8.75152 17V6.33333H7.25152V17H8.75152ZM11.7319 9.003L8.53185 5.803L7.47119 6.86366L10.6712 10.0637L11.7319 9.003ZM7.47119 5.803L4.27119 9.003L5.33185 10.0637L8.53185 6.86366L7.47119 5.803ZM5.33485 13.5826H3.73343V15.0826H5.33485V13.5826ZM3.73343 13.5826C3.36655 13.5826 3.01469 13.4369 2.75527 13.1775L1.69461 14.2381C2.23534 14.7788 2.96872 15.0826 3.73343 15.0826V13.5826ZM2.75527 13.1775C2.49584 12.918 2.3501 12.5662 2.3501 12.1993H0.850098C0.850098 12.964 1.15388 13.6974 1.69461 14.2381L2.75527 13.1775ZM2.3501 12.1993V3.13333H0.850098V12.1993H2.3501ZM2.3501 3.13333C2.3501 2.76645 2.49584 2.41459 2.75527 2.15517L1.69461 1.09451C1.15388 1.63524 0.850098 2.36863 0.850098 3.13333H2.3501ZM2.75527 2.15517C3.01469 1.89574 3.36655 1.75 3.73343 1.75V0.25C2.96872 0.25 2.23534 0.553779 1.69461 1.09451L2.75527 2.15517ZM3.73343 1.75H12.2668V0.25H3.73343V1.75ZM12.2668 1.75C12.6336 1.75 12.9855 1.89574 13.2449 2.15517L14.3056 1.09451C13.7649 0.553779 13.0315 0.25 12.2668 0.25V1.75ZM13.2449 2.15517C13.5044 2.41459 13.6501 2.76645 13.6501 3.13333H15.1501C15.1501 2.36863 14.8463 1.63524 14.3056 1.09451L13.2449 2.15517ZM13.6501 3.13333V12.1993H15.1501V3.13333H13.6501ZM13.6501 12.1993C13.6501 12.5662 13.5044 12.918 13.2449 13.1775L14.3056 14.2381C14.8463 13.6974 15.1501 12.964 15.1501 12.1993H13.6501ZM13.2449 13.1775C12.9855 13.4369 12.6336 13.5826 12.2668 13.5826V15.0826C13.0315 15.0826 13.7649 14.7788 14.3056 14.2381L13.2449 13.1775ZM12.2668 13.5826H10.6668V15.0826H12.2668V13.5826Z"
          fill={color}
        />
      </svg>
    ),
  });
};

export const starIcon = (
  color: string,
  outlineColor: string,
): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6773 3.24014L12.5897 7.11507H16.7466C16.8905 7.11506 17.0313 7.15621 17.1524 7.23367C17.2736 7.31112 17.3701 7.42165 17.4304 7.55218C17.4908 7.68272 17.5125 7.8278 17.4931 7.97029C17.4736 8.11278 17.4138 8.24672 17.3206 8.35628L14.1876 12.0372L15.3148 16.2248C15.3517 16.3633 15.3484 16.5095 15.3051 16.6462C15.2619 16.7828 15.1805 16.9043 15.0706 16.9964C14.9607 17.0884 14.8269 17.1472 14.6847 17.1658C14.5426 17.1844 14.3981 17.162 14.2682 17.1014L10.002 15.0796L5.87575 17.0987C5.74739 17.1623 5.60356 17.1879 5.46115 17.1726C5.31873 17.1573 5.18362 17.1017 5.07167 17.0124C4.95972 16.923 4.87557 16.8036 4.82908 16.6681C4.78259 16.5327 4.77569 16.3867 4.80919 16.2475L5.81243 12.0372L2.67941 8.35628C2.58625 8.24672 2.5264 8.11278 2.50693 7.97029C2.48747 7.8278 2.5092 7.68272 2.56956 7.55218C2.62992 7.42165 2.72638 7.31112 2.84755 7.23367C2.96873 7.15621 3.10954 7.11506 3.25335 7.11507H7.41426L9.32674 3.24014C9.3888 3.114 9.48496 3.00777 9.60431 2.93348C9.72365 2.8592 9.86142 2.81982 10.002 2.81982C10.1426 2.81982 10.2803 2.8592 10.3997 2.93348C10.519 3.00777 10.6152 3.114 10.6773 3.24014V3.24014Z"
          stroke={outlineColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  });
};

export const attachmentIcon = (
  color: string,
): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 6.97119L8.68201 14.2898C7.8381 15.1338 6.6935 15.6079 5.50002 15.6079C4.30654 15.6079 3.16194 15.1338 2.31803 14.2898C1.47411 13.4459 1 12.3013 1 11.1078C1 9.91437 1.47411 8.76977 2.31803 7.92585L8.32868 1.91586C8.60542 1.62933 8.93645 1.40079 9.30246 1.24356C9.66848 1.08633 10.0621 1.00357 10.4605 1.00011C10.8588 0.996652 11.2538 1.07256 11.6225 1.2234C11.9912 1.37424 12.3262 1.597 12.6079 1.87868C12.8895 2.16036 13.1123 2.49531 13.2631 2.864C13.414 3.23269 13.4899 3.62773 13.4864 4.02606C13.483 4.4244 13.4002 4.81806 13.243 5.18407C13.0857 5.55008 12.8572 5.88112 12.5707 6.15786L6.56068 12.1712C6.27782 12.4445 5.89895 12.5957 5.50565 12.5924C5.11235 12.589 4.73611 12.4313 4.45796 12.1532C4.1798 11.8752 4.02199 11.499 4.01851 11.1057C4.01503 10.7124 4.16616 10.3335 4.43935 10.0505L10.45 4.03786"
          stroke="#232323"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  });
};

export const unionIcon = (color: string): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="40"
        height="40"
        transform-origin="center"
        viewBox="0 0 20 20"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.94099 10H0.0153303L3.77898 5.00946L0.000244141 0H2.92608L6.70534 5.00946L2.94099 10ZM7.5105 10H4.58485L8.34866 5.00946L4.56976 0H7.49559L11.2748 5.00946L7.5105 10Z"
          fill="#A7A7A7"
        />
      </svg>
    ),
  });
};

export const locationIcon = (
  color: string,
): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.51758 8.23607C7.51758 8.95692 7.80394 9.64826 8.31366 10.158C8.82339 10.6677 9.51472 10.9541 10.2356 10.9541C10.9564 10.9541 11.6478 10.6677 12.1575 10.158C12.6672 9.64826 12.9536 8.95692 12.9536 8.23607C12.9536 7.51521 12.6672 6.82387 12.1575 6.31415C11.6478 5.80443 10.9564 5.51807 10.2356 5.51807C9.51472 5.51807 8.82339 5.80443 8.31366 6.31415C7.80394 6.82387 7.51758 7.51521 7.51758 8.23607V8.23607Z"
          stroke="#A7A7A7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4652 8.23259C17.4652 14.5812 11.8945 18.142 10.5307 18.9207C10.4398 18.9727 10.3369 19 10.2322 19C10.1275 19 10.0246 18.9727 9.93364 18.9207C8.5699 18.1412 3 14.5796 3 8.23259C3 6.31439 3.762 4.47475 5.11838 3.11838C6.47475 1.762 8.31439 1 10.2326 1C12.1508 1 13.9904 1.762 15.3468 3.11838C16.7032 4.47475 17.4652 6.31439 17.4652 8.23259Z"
          stroke="#A7A7A7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  });
};

export const errorIcon = (color: string): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.00018 0.00168586C6.59129 0.0392716 4.29374 1.0224 2.60328 2.73893C1.76186 3.58023 1.09796 4.58194 0.650953 5.68464C0.203945 6.78735 -0.0170662 7.9686 0.00102763 9.15832C3.95253e-05 10.3203 0.22831 11.4711 0.672765 12.5448C1.11722 13.6184 1.76912 14.5939 2.59114 15.4152C3.41316 16.2365 4.38913 16.8876 5.46316 17.3311C6.5372 17.7747 7.68818 18.002 8.85019 18H9.00018C11.4075 17.9782 13.7077 17.0015 15.3951 15.2845C17.0826 13.5675 18.0193 11.2507 17.9993 8.84335C18.0015 7.6683 17.7691 6.50463 17.3157 5.42058C16.8623 4.33654 16.1969 3.35395 15.3587 2.53042C14.5205 1.7069 13.5264 1.05903 12.4345 0.624796C11.3426 0.190566 10.175 -0.0212782 9.00018 0.00168586ZM7.87528 12.4055C7.86915 12.2547 7.89383 12.1043 7.9478 11.9634C8.00177 11.8225 8.08391 11.6941 8.18919 11.586C8.29447 11.4779 8.42069 11.3924 8.56013 11.3347C8.69957 11.2771 8.8493 11.2485 9.00018 11.2506C9.29555 11.2523 9.57888 11.3679 9.79121 11.5732C10.0035 11.7786 10.1285 12.0579 10.1401 12.353C10.1461 12.5015 10.1221 12.6497 10.0694 12.7887C10.0168 12.9277 9.93651 13.0546 9.83354 13.1618C9.73056 13.269 9.60697 13.3542 9.4702 13.4124C9.33343 13.4706 9.18631 13.5005 9.03767 13.5004C8.73967 13.5046 8.45171 13.3927 8.23476 13.1883C8.01781 12.984 7.88889 12.7032 7.87528 12.4055ZM8.25025 9.4058V4.90622C8.25025 4.70733 8.32926 4.51658 8.4699 4.37594C8.61054 4.2353 8.80128 4.15629 9.00018 4.15629C9.19907 4.15629 9.38982 4.2353 9.53046 4.37594C9.6711 4.51658 9.75011 4.70733 9.75011 4.90622V9.4058C9.75011 9.60469 9.6711 9.79544 9.53046 9.93608C9.38982 10.0767 9.19907 10.1557 9.00018 10.1557C8.80128 10.1557 8.61054 10.0767 8.4699 9.93608C8.32926 9.79544 8.25025 9.60469 8.25025 9.4058Z"
          fill="#ED3054"
        />
      </svg>
    ),
  });
};

export const downloadIcon = (): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.7513 2C10.7513 1.58579 10.4155 1.25 10.0013 1.25C9.5871 1.25 9.25132 1.58579 9.25132 2H10.7513ZM10.0013 12.6671L9.47099 13.1975C9.76388 13.4904 10.2388 13.4904 10.5316 13.1975L10.0013 12.6671ZM7.3315 8.93667C7.03861 8.64377 6.56374 8.64378 6.27084 8.93667C5.97795 9.22956 5.97795 9.70444 6.27084 9.99733L7.3315 8.93667ZM13.7318 9.99733C14.0247 9.70444 14.0247 9.22956 13.7318 8.93667C13.4389 8.64378 12.964 8.64377 12.6711 8.93667L13.7318 9.99733ZM12.6681 3.91607C12.2539 3.91607 11.9181 4.25186 11.9181 4.66607C11.9181 5.08029 12.2539 5.41607 12.6681 5.41607V3.91607ZM16.4002 6.7995H17.1502H16.4002ZM16.4002 15.8666H17.1502H16.4002ZM14.2668 18V18.75V18ZM5.73304 18V18.75V18ZM3.59961 15.8666H2.84961H3.59961ZM3.59961 6.7995H2.84961H3.59961ZM5.73304 4.66607V3.91607V4.66607ZM7.33311 5.41607C7.74732 5.41607 8.08311 5.08029 8.08311 4.66607C8.08311 4.25186 7.74732 3.91607 7.33311 3.91607V5.41607ZM9.25132 2V12.6671H10.7513V2H9.25132ZM6.27084 9.99733L9.47099 13.1975L10.5316 12.1368L7.3315 8.93667L6.27084 9.99733ZM10.5316 13.1975L13.7318 9.99733L12.6711 8.93667L9.47099 12.1368L10.5316 13.1975ZM12.6681 5.41607H14.2668V3.91607H12.6681V5.41607ZM14.2668 5.41607C14.6337 5.41607 14.9855 5.56183 15.245 5.82127L16.3056 4.76061C15.7649 4.21986 15.0315 3.91607 14.2668 3.91607V5.41607ZM15.245 5.82127C15.5044 6.08071 15.6502 6.43259 15.6502 6.7995H17.1502C17.1502 6.03477 16.8464 5.30136 16.3056 4.76061L15.245 5.82127ZM15.6502 6.7995V15.8666H17.1502V6.7995H15.6502ZM15.6502 15.8666C15.6502 16.2335 15.5044 16.5854 15.245 16.8448L16.3056 17.9055C16.8464 17.3647 17.1502 16.6313 17.1502 15.8666H15.6502ZM15.245 16.8448C14.9855 17.1042 14.6337 17.25 14.2668 17.25V18.75C15.0315 18.75 15.7649 18.4462 16.3056 17.9055L15.245 16.8448ZM14.2668 17.25H5.73304V18.75H14.2668V17.25ZM5.73304 17.25C5.36613 17.25 5.01425 17.1042 4.75481 16.8448L3.69415 17.9055C4.23489 18.4462 4.9683 18.75 5.73304 18.75V17.25ZM4.75481 16.8448C4.49536 16.5854 4.34961 16.2335 4.34961 15.8666H2.84961C2.84961 16.6313 3.1534 17.3647 3.69415 17.9055L4.75481 16.8448ZM4.34961 15.8666V6.7995H2.84961V15.8666H4.34961ZM4.34961 6.7995C4.34961 6.43259 4.49536 6.08071 4.75481 5.82127L3.69415 4.76061C3.1534 5.30136 2.84961 6.03477 2.84961 6.7995H4.34961ZM4.75481 5.82127C5.01425 5.56183 5.36613 5.41607 5.73304 5.41607V3.91607C4.9683 3.91607 4.23489 4.21986 3.69415 4.76061L4.75481 5.82127ZM5.73304 5.41607H7.33311V3.91607H5.73304V5.41607Z"
          fill="#232323"
        />
      </svg>
    ),
  });
};

export const peopleIcon = (
  color: string,
): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="20"
        height="15"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 14.2C1 12.7678 1.56893 11.3943 2.58162 10.3816C3.59432 9.36893 4.96783 8.8 6.4 8.8C7.83217 8.8 9.20568 9.36893 10.2184 10.3816C11.2311 11.3943 11.8 12.7678 11.8 14.2M13.0504 10.0544C13.7185 9.80816 14.4361 9.72694 15.1423 9.81763C15.8485 9.90833 16.5224 10.1683 17.1065 10.5753C17.6907 10.9823 18.1679 11.5245 18.4976 12.1555C18.8272 12.7866 18.9996 13.488 19 14.2M3.1 4.3C3.1 5.17521 3.44768 6.01458 4.06655 6.63345C4.68542 7.25232 5.52479 7.6 6.4 7.6C7.27521 7.6 8.11458 7.25232 8.73345 6.63345C9.35232 6.01458 9.7 5.17521 9.7 4.3C9.7 3.42479 9.35232 2.58542 8.73345 1.96655C8.11458 1.34768 7.27521 1 6.4 1C5.52479 1 4.68542 1.34768 4.06655 1.96655C3.44768 2.58542 3.1 3.42479 3.1 4.3ZM11.8816 6.1C11.8816 6.81608 12.166 7.50284 12.6724 8.00919C13.1787 8.51554 13.8655 8.8 14.5816 8.8C15.2976 8.8 15.9844 8.51554 16.4908 8.00919C16.9971 7.50284 17.2816 6.81608 17.2816 6.1C17.2816 5.38392 16.9971 4.69716 16.4908 4.19081C15.9844 3.68446 15.2976 3.4 14.5816 3.4C13.8655 3.4 13.1787 3.68446 12.6724 4.19081C12.166 4.69716 11.8816 5.38392 11.8816 6.1Z"
          stroke={color}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  });
};

export const errorAMTIcon = (): ComponentWithAs<"svg", IconProps> => {
  return createIcon({
    path: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5564 13.3361C11.5405 12.934 11.3702 12.5535 11.0809 12.2737C10.7919 11.9942 10.4064 11.8368 10.0045 11.834C9.79752 11.8312 9.59217 11.8706 9.40091 11.9497C9.20912 12.029 9.03552 12.1466 8.89071 12.2953C8.74591 12.4439 8.63293 12.6206 8.5587 12.8144C8.48446 13.0082 8.45053 13.2151 8.45896 13.4225L8.45905 13.4245C8.4776 13.8304 8.65334 14.2131 8.94907 14.4916C9.24404 14.7695 9.63529 14.922 10.0404 14.9171C10.2442 14.9168 10.4458 14.8756 10.6333 14.7958C10.8218 14.7156 10.9921 14.5982 11.134 14.4505C11.2759 14.3028 11.3865 14.1279 11.4591 13.9364C11.5316 13.7449 11.5647 13.5407 11.5564 13.3361ZM11.5564 13.3361C11.5564 13.3361 11.5564 13.3361 11.5564 13.336L11.1401 13.353L11.5564 13.3367C11.5564 13.3365 11.5564 13.3363 11.5564 13.3361ZM10.0067 1.41831L10.0083 1.41827C11.1277 1.39639 12.2402 1.59824 13.2805 2.01197C14.3208 2.4257 15.2681 3.04299 16.0667 3.82764C16.8653 4.61229 17.4993 5.5485 17.9313 6.58137C18.3633 7.61424 18.5848 8.72298 18.5826 9.84256L18.5827 9.84681C18.6017 12.1437 17.708 14.3542 16.098 15.9924C14.4884 17.6302 12.2945 18.562 9.99828 18.5833L9.85019 18.5833L9.84948 18.5833C8.74228 18.5852 7.64558 18.3686 6.62221 17.946C5.59883 17.5234 4.66889 16.903 3.88564 16.1204C3.1024 15.3378 2.48124 14.4084 2.05775 13.3854C1.63426 12.3624 1.41675 11.2659 1.41769 10.1587H1.41775L1.41765 10.152C1.4004 9.01804 1.61105 7.89218 2.0371 6.84118C2.46315 5.79017 3.09592 4.83543 3.89789 4.03358L3.8979 4.03358L3.90016 4.03129C5.51388 2.39268 7.70714 1.45418 10.0067 1.41831ZM8.83358 5.90622V10.4058C8.83358 10.7152 8.95649 11.0119 9.17527 11.2307C9.39405 11.4495 9.69078 11.5724 10.0002 11.5724C10.3096 11.5724 10.6063 11.4495 10.8251 11.2307C11.0439 11.0119 11.1668 10.7152 11.1668 10.4058V5.90622C11.1668 5.59682 11.0439 5.30009 10.8251 5.08132C10.6063 4.86254 10.3096 4.73963 10.0002 4.73963C9.69078 4.73963 9.39405 4.86254 9.17527 5.08131C8.95649 5.30009 8.83358 5.59682 8.83358 5.90622Z"
          fill="#ED3054"
          stroke="#ED3054"
          strokeWidth="0.833333"
        />
      </svg>
    ),
  });
};
